<template>
  <li :class="className">
    <slot />
  </li>
</template>

<script>
import { ElementMixin } from "vue-slicksort";

export default {
  props: ["className"],
  mixins: [ElementMixin]
};
</script>
